export default __webpack_public_path__ + "static/media/phone.b7048034.svg";